// extracted by mini-css-extract-plugin
export default {"impression":"impression_impression__UeyAz","actions":"impression_actions__HRfjA","button":"impression_button__R6QvN","question":"impression_question__tHqrV"};